import { Color } from "../../../utils";

export enum AtTagVariant {
  CONTAINED = "contained",
  OUTLINED = "outlined",
}

export enum AtTagType {
  CAMPAIGNS = "campaigns",
  NUMBER = "number",
  ACCOUNTS = "accounts",
  FOLIO = "folio",
  ORGANIZATION = "organization",
  NOTE = "note",
}

export type AtTagCampaignsProps = {
  label: string;
  type: AtTagType.CAMPAIGNS;
};

export enum AtTagNumberVariant {
  FOLIO = "folio",
  EMPLOYEE_NUMBER = "employeeNumber",
  ORDER = "order",
}
export type AtTagNumberProps = {
  label: string;
  type: AtTagType.NUMBER;
  variant: AtTagNumberVariant;
};

export enum AtTagFolioStatus {
  OPEN = "open",
  CLOSED = "closed",
  ACTIVE = "active",
}
export type AtTagFolioProps = {
  type: AtTagType.FOLIO;
  status: AtTagFolioStatus;
};

export enum AtTagOrganizationStatus {
  LIVERPOOL = "liverpool",
  SUBURBIA = "suburbia",
}
export type AtTagOrganizationProps = {
  type: AtTagType.ORGANIZATION;
  status: AtTagOrganizationStatus;
};

export type AtTagNoteProps = {
  type: AtTagType.NOTE;
  color: Color;
  text: string;
};

export enum AtTagAccountsStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
export type AtTagAccountsProps = {
  type: AtTagType.ACCOUNTS;
  status: AtTagAccountsStatus;
};

export type AtTagProps =
  | AtTagCampaignsProps
  | AtTagNumberProps
  | AtTagFolioProps
  | AtTagAccountsProps
  | AtTagOrganizationProps
  | AtTagNoteProps;
